import { useState } from 'react';
import { Box, makeStyles, ButtonBase } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { ArrowLeftIcon } from '../../../components/Icon';
import Tab from '../../../components/Tab';
import { useActionableTicketReminder } from '../../../utils/hooks';
import { i18n } from '../../../language';
import RemarkList from './RemarkList';
import ActionableAlert from './ActionableAlert';
import SOPDViewSetting from './SOPDViewSetting';
import TransferIn from './TransferIn';

const useStyles = makeStyles((theme) => ({
  backBtn: {
    gap: '0.5rem',
    color: '#538FFF',
    fontSize: '1rem',
    fontFamily: 'NotoSans-Bold',
  },
  arrowLeftIcon: {
    color: '#538FFF',
    fontSize: '1rem',
  },
  tabBox: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 14rem)',
    padding: '1.87rem',
    borderRadius: '0 15px 15px 15px',
    background: '#FFF',
  },
}));

const AdmissionSetting = () => {
  const classes = useStyles();
  const history = useHistory();
  useActionableTicketReminder('audio', 'AD');

  const tabs = [
    {
      value: 'Emergency Admission Remarks',
      text: 'Emergency Admission Remarks',
    },
    {
      value: 'Special Alert',
      text: 'Special Alert',
    },
    {
      value: 'Actionable Alert',
      text: 'Actionable Alert',
    },
    {
      value: 'Specialty Remark',
      text: 'Specialty Remark',
    },
    {
      value: 'TRANSFER_IN_SETTING',
      text: i18n.t('EADMISSION_TRANSFER_IN'),
    },
    {
      value: 'SOPD_VIEW',
      text: i18n.t('EADMISSION_SOPD_LOCATION_VIEW'),
    },
  ];
  const [tabValue, setTabValue] = useState('Emergency Admission Remarks');

  const getContainerStyle = () => {
    if (tabValue === 'SOPD_VIEW') {
      return { overflow: 'visible', position: 'relative' };
    } else if (tabValue === 'Actionable Alert') {
      return { overflow: 'auto' };
    } else {
      return { overflow: 'hidden' };
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        pl="2.63rem"
        height="4.375rem"
        bgcolor="#FFF"
        boxShadow="0px 1px 0px 0px #E4E7EB"
      >
        <ButtonBase className={classes.backBtn} onClick={() => history.push('/admission')}>
          <ArrowLeftIcon className={classes.arrowLeftIcon} /> Back
        </ButtonBase>
      </Box>
      <Box p="1.25rem 3.44rem 0">
        <Tab
          tabs={tabs}
          value={tabValue}
          onChange={(value) => {
            setTabValue(value);
          }}
          width="11.5625rem"
          p="0.56rem 0.81rem"
        />
        <Box className={classes.tabBox} style={getContainerStyle()}>
          {tabValue === 'Emergency Admission Remarks' && <RemarkList tabValue={tabValue} />}
          {tabValue === 'Special Alert' && <RemarkList tabValue={tabValue} />}
          {tabValue === 'Actionable Alert' && <ActionableAlert admission={true} />}
          {tabValue === 'Specialty Remark' && <RemarkList tabValue={tabValue} />}
          {tabValue === 'TRANSFER_IN_SETTING' && <TransferIn tabValue={tabValue} />}
          {tabValue === 'SOPD_VIEW' && <SOPDViewSetting tabValue={tabValue} />}
        </Box>
      </Box>
    </>
  );
};

export default AdmissionSetting;
